import { GeneratedTableColumn } from "./GeneratedTableColumn";
import { SelectCheckboxHeadingTableCell } from "./SelectCheckboxHeadingTableCell";
import { SelectCheckboxTableCell } from "./SelectCheckboxTableCell";
import { Table } from "./Table";
import { TableColumnProps } from "./TableColumnProps";

export class SelectCheckboxTableColumn extends GeneratedTableColumn {
    constructor(props?: Partial<TableColumnProps>) {
        super(props);
        this.headingDef = this.createHeadingCell();
        this.cellDef = this.createCellDef(this.table);
    }

    private createHeadingCell(): SelectCheckboxHeadingTableCell {
        return new SelectCheckboxHeadingTableCell({
            fixedWidth: SelectCheckboxTableCell.FIXED_WIDTH,
            id: "columnHeaderCheckboxes",
            table: this.table,
        });
    }

    private createCellDef(table: Table): any {
        return {
            def: {
                cellProps: { table },
                type: "selectcheckboxcell"
             }
        };
    }
}
